import request from '@/utils/request'

// 获取未读消息数量
export function unreadMsg(query) {
    return request({
        url: '/user/message/unread',
        method: 'get',
        params: query
    })
}

// 获取用户消息列表
export function msgList(query) {
    return request({
        url: '/user/message/index',
        method: 'get',
        params: query
    })
}

export function noticeList(query) {
    return request({
        url: '/user/notice/index',
        method: 'get',
        params: query
    })
}

// 获取用户消息列表
export function readMsg(query) {
    return request({
        url: '/user/message/read',
        method: 'get',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/api/system.js